import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";

interface TotalGuidingErrorChartProps {
  imagesForView: ImageMetadata[];
}

const TotalGuidingErrorChart: React.FC<TotalGuidingErrorChartProps> = ({
  imagesForView,
}) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      borderRadius: 3,
      p: 3,
      boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      minHeight: 400,
    }}
  >
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
    >
      Total Guiding Error
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      RMS guiding error throughout the session
    </Typography>
    {imagesForView.length === 0 ? (
      <Typography color="text.secondary">No data available.</Typography>
    ) : (
      <ResponsiveContainer width="100%" height={280}>
        <LineChart
          data={imagesForView.map((img, i) => ({
            frame: i + 1,
            rms: img.GuidingRMSArcSec,
          }))}
        >
          <XAxis
            dataKey="frame"
            stroke="#a0a0a0"
            tick={{ fill: "#a0a0a0" }}
            tickLine={false}
            axisLine={{ stroke: "#333" }}
          />
          <YAxis
            stroke="#a0a0a0"
            tick={{ fill: "#a0a0a0" }}
            tickLine={false}
            axisLine={{ stroke: "#333" }}
            domain={[0, "auto"]}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (!active || !payload || !payload.length) return null;
              return (
                <div
                  style={{
                    background: "#222",
                    border: "1px solid #444",
                    color: "#fff",
                    padding: 8,
                    borderRadius: 4,
                  }}
                >
                  <div>Frame: {label}</div>
                  <div>Total RMS (Arc-sec): {payload[0].value}</div>
                </div>
              );
            }}
          />
          <Line
            type="monotone"
            dataKey="rms"
            stroke="#4fc3f7"
            strokeWidth={2}
            dot={{ r: 2, fill: "#4fc3f7" }}
          />
        </LineChart>
      </ResponsiveContainer>
    )}
  </Box>
);

export default TotalGuidingErrorChart;
